module.exports = __webpack_public_path__ + "static/img/logo_tit.48a6d88e.png";